/**
 * ダッシュボード画面画面のメッセージクラス
 *
 * @export DashboardMessageInfo
 * @class DashboardMessageInfo
 */
export class DashboardMessageInfo {
    /** ユーザID */
    public userId: string = String('');
    /** メッセージ表示日 */
    public messageShowDate: string = String('');
    /** 工程管理情報 */
    public ProcessControlList: ProcessControlListModel[] = [];
    /** 警告・エラー情報 */
    public CautionErrorList: CautionErrorListModel[] = [];
    /** メッセージ情報 */
    public MessageInfoList: MessageInfoListModel[] = [];
}

export class ProcessControlListModel {
    constructor(
        /** 工程管理メッセージ */
        public PCMessage: string = String(''),
        /** 工程管理画面ID */
        public PCFormId: string = String(''),
    ){}
}

export class CautionErrorListModel {
    constructor(
        /** 警告・エラーメッセージ */
        public CEMessage: string = String(''),
        /** 警告・エラー画面ID */
        public CEFormId: string = String(''),
    ){}
}

export class MessageInfoListModel {
    constructor(
        /** メッセージ情報メッセージ */
        public MIMessage: string = String(''),
        /** メッセージ情報画面ID */
        public MIFormId: string = String(''),
    ){}
}